/* global debounce */
if (!customElements.get('m-back-to-top')) {
  class MBackToTop extends HTMLElement {
    constructor() {
      super();
      this.style.display = 'none';
      this.toggleVisibilityOnScroll = this.toggleVisibilityOnScroll.bind(this);
      this.init();
    }

    connectedCallback() {
      this.addEventListener('click', this.scrollToTop);
      window.addEventListener('scroll', this.toggleVisibilityOnScroll.bind(this));
      this.toggleVisibilityOnScroll();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.scrollToTop);
      window.removeEventListener('scroll', this.toggleVisibilityOnScroll.bind(this));
    }

    init() {
      this.debouncedToggleVisibility = debounce(this.toggleVisibilityOnScroll.bind(this), 300);
    }

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }

    toggleVisibilityOnScroll() {
      if (window.scrollY > 500) {
        this.style.display = 'flex';
      } else {
        this.style.display = 'none';
      }
    }
  }

  customElements.define('m-back-to-top', MBackToTop);
}
